export function KeelsonMark({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Keelson mark"
      style={{ display: "block", flexShrink: 0 }}
    >
      <rect x="6" y="34" width="36" height="5" rx="2" fill="currentColor" />
      <rect x="9" y="26" width="30" height="5" rx="2" fill="currentColor" />
      <rect x="21.5" y="9" width="5" height="17" rx="1.5" fill="currentColor" />
      <rect x="13" y="15" width="5" height="11" rx="1.5" fill="currentColor" />
      <rect x="30" y="15" width="5" height="11" rx="1.5" fill="currentColor" />
    </svg>
  );
}
